import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import recibos from './recibos';

export default combineReducers({
    alert, loader, breadcrumb, recibos
});